import { render, staticRenderFns } from "./MessageTemplateModal.vue?vue&type=template&id=4de36590&scoped=true"
import script from "./MessageTemplateModal.vue?vue&type=script&lang=ts"
export * from "./MessageTemplateModal.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplateModal.vue?vue&type=style&index=0&id=4de36590&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de36590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4de36590')) {
      api.createRecord('4de36590', component.options)
    } else {
      api.reload('4de36590', component.options)
    }
    module.hot.accept("./MessageTemplateModal.vue?vue&type=template&id=4de36590&scoped=true", function () {
      api.rerender('4de36590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message-template/components/MessageTemplateModal.vue"
export default component.exports